import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AuthorizationDocumentDetail,
  RelatedDocumentContent,
} from "core/http/service/authorizationDocument/resTypes";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: AuthorizationDocumentDetail | null;
  relatedDocumentContent: RelatedDocumentContent | null;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
  relatedDocumentContent: null,
};

const getAuthorizationDocsDetailSlice = createSlice({
  name: "getAuthorizationDocsDetail",
  initialState,
  reducers: {
    getAuthorizationDocsDetailStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getAuthorizationDocsDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    setRelatedDocumentContent: (
      state,
      action: PayloadAction<RelatedDocumentContent>
    ) => {
      state.relatedDocumentContent = action.payload;
    },
    resetRelatedDocumentContent: (state) => {
      state.relatedDocumentContent = null;
    },
    getAuthorizationDocsDetailFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetAuthorizationDocsDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  getAuthorizationDocsDetailStart,
  getAuthorizationDocsDetailSuccess,
  getAuthorizationDocsDetailFailed,
  resetAuthorizationDocsDetail,
  setRelatedDocumentContent,
  resetRelatedDocumentContent,
} = getAuthorizationDocsDetailSlice.actions;

export default getAuthorizationDocsDetailSlice.reducer;
